import { cn } from '@/utils';
type BottomLabelProps = {
  helperText: string;
  error?: boolean;
};
const BottomLabel = ({
  helperText,
  error
}: BottomLabelProps) => {
  return <span className={cn('pl-xs text-caption-md-medium text-assistive', error && 'text-destructive')} data-sentry-component="BottomLabel" data-sentry-source-file="BottomLabel.tsx">
      {helperText}
    </span>;
};
export { BottomLabel, type BottomLabelProps };